module.exports = "../study/imgs/maps/Tokyo/S8/Helth/HeatStress/Tokyo_HeatStress_MRI_RCP85_End.png";